import React from 'react';

import clsx from 'clsx';
import PropTypes from 'prop-types';

// Components
import { Mui } from 'components';
import * as DisplayData from 'components/common/DisplayData';

const useStyles = Mui.makeStyles(theme => ({
  root: {
    display: 'flex',
    height: '100%',
    minHeight: '100%',
    flexDirection: 'column',
    paddingBottom: 80,
    paddingTop: 80,
  },
  avatar: {
    backgroundColor: theme.palette.primary.main,
  },
  optional: {
    backgroundColor: 'transparent',
    color: theme.palette.text.secondary,
    border: `1px solid ${theme.palette.divider}`,
  },
}));

function Step(props) {
  const {
    children,
    step,
    title,
    subheader,
    open,
    checked,
    disabled,
    onClick,
    cleared,
    optional,
    ...restProps
  } = props;

  // Hooks
  const classes = useStyles(props);

  // Constants
  const avatar = (
    <Mui.Avatar className={clsx(classes.avatar, optional && classes.optional)}>{step}</Mui.Avatar>
  );

  if (open) {
    return (
      <Mui.Card {...restProps} variant="outlined">
        <Mui.CardHeader avatar={avatar} title={title} subheader={subheader} />
        <Mui.CardContent>{children}</Mui.CardContent>
      </Mui.Card>
    );
  }

  return (
    <Mui.Card variant="outlined">
      <Mui.CardActionArea onClick={!disabled ? onClick : undefined} disabled={disabled}>
        <Mui.CardHeader
          avatar={avatar}
          action={!open && cleared && <DisplayData.BooleanField value={checked} />}
          title={title}
          subheader={subheader}
        />
      </Mui.CardActionArea>
    </Mui.Card>
  );
}

Step.propTypes = {
  children: PropTypes.any,
  step: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  title: PropTypes.string,
  subheader: PropTypes.string,
  open: PropTypes.bool,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  cleared: PropTypes.bool,
  optional: PropTypes.bool,
  onClick: PropTypes.func,
};

export default Step;
